
import React from "react";
import MdaeCopyText from "../common_widgets/copy-text";
import MdaeSwitch from "../common_widgets/switch";
import "./index.scss";

export const LabelWithCopyText = ({ label, value, title }) => (
  <div className="single-line-flex-box-25-width">
    <div className="mdae-data-field-label">{label}</div>
    <div className="mdae-data-field-content text-overflow" title={title || value}>
      &nbsp;{value}
    </div>
    <MdaeCopyText
      className="copy-text copy-action-icon-white"
      textToCopy={value}
    />
  </div>
);


export const ToggleLabelWithCopyText = ({
  toggleValue,
  onToggleChange,
  labelOn,
  labelOff,
  value,
  showSwitch = true,
  title,
  className=''
}) => (
  <div className={`${className ?? ''} single-line-flex-box-25-width`}>
    {showSwitch && (
      <div className="user-task-switch-container">
        <MdaeSwitch value={toggleValue} onValueChanged={onToggleChange} />
      </div>
    )}
    <div className="mdae-data-field-label">
      {toggleValue ? labelOn : labelOff}
    </div>
    <div className="mdae-data-field-content text-overflow" title={title || value}>
      &nbsp;{value}
    </div>
    <MdaeCopyText
      className="copy-text copy-action-icon-white"
      textToCopy={value}
    />
  </div>
);
